import { getApiUrl, getResource, fetchWithRetry } from "./APIOperations";

// FOLDER OPERATIONS
export const createFolderAPI = async (parentPath, newFolderName) => {
  const apiURL = getApiUrl(`/api/folders/create`);
  try {
    const response = await fetchWithRetry(apiURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ parentPath, newFolderName }),
    });

    const data = await response.json();

    if (!response.ok){
      throw new Error(data.status.error);
    }

    return { success: true, result: data };
  } catch (error) {
    console.error(`Failed to create folder: ${error}`);
    return { success: false, error: String(error) };
  }
};

export const moveFolderAPI = async (sourceParentPath, folderName, destinationPath) => {
  const apiURL = getApiUrl(`/api/folders/move`);
  try {
    const response = await fetchWithRetry(apiURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sourceParentPath, itemName: folderName, destinationPath }),
    });

    const data = await response.json();

    if (!response.ok){
      throw new Error(data.status.error);
    }

    return { success: true, result: data };
  } catch (error) {
    console.error(`Failed to move folder: ${error}`);
    return { success: false, error: String(error) };
  }
};

export const deleteFolderAPI = async (parentPath, folderName) => {
  const apiURL = getApiUrl(`/api/folders/delete`);
  try {
    const response = await fetchWithRetry(apiURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ parentPath, itemName: folderName }),
    });

    const data = await response.json();

    if (!response.ok){
      throw new Error(data.status.error);
    }

    return { success: true, result: data };
  } catch (error) {
    console.error(`Failed to delete folder: ${error}`);
    return { success: false, error: String(error) };
  }
};

export const moveFileAPI = async (sourceParentPath, fileName, destinationPath) => {
  const apiURL = getApiUrl(`/api/folders/files/move`);
  try {
    const response = await fetchWithRetry(apiURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sourceParentPath, itemName: fileName, destinationPath }),
    });

    const data = await response.json();

    if (!response.ok){
      throw new Error(data.status.error);
    }

    return { success: true, result: data };
  } catch (error) {
    console.error(`Failed to move file: ${error}`);
    return { success: false, error: String(error) };
  }
};

export const deleteFileAPI = async (parentPath, fileName) => {
  const apiURL = getApiUrl(`/api/folders/files/delete`);
  try {
    const response = await fetchWithRetry(apiURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ parentPath, itemName: fileName }),
    });

    const data = await response.json();

    if (!response.ok){
      throw new Error(data.status.error);
    }

    return { success: true, result: data };
  } catch (error) {
    console.error(`Failed to delete file: ${error}`);
    return { success: false, error: String(error) };
  }
};

export const getProjectList = async () => {
  try {
    const data = await getResource(`/api/folders/projects`);
    return data.result;
  } catch (error) {
    console.error(`Error: ${error}`);
    return null;
  }
};